import { render } from "./coinList.vue?vue&type=template&id=15cd5db6&scoped=true"
import script from "./coinList.vue?vue&type=script&lang=js"
export * from "./coinList.vue?vue&type=script&lang=js"

import "./coinList.vue?vue&type=style&index=0&id=15cd5db6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cd5db6"]])

export default __exports__